export const trackingItems = [
  {
    date: '09-10',
    articleId: '1001',
    title: '剧组换角传闻进入多方核实阶段',
    status: '多方信源',
    note: '三位组内读者说法在时间上一致，原因尚未统一。',
  },
  {
    date: '09-08',
    articleId: '1002',
    title: '综艺录制排期调整，确认为行程协调',
    status: '已核实',
    note: '场馆排期与观众招募信息相互印证。',
  },
  {
    date: '09-07',
    articleId: '1003',
    title: '折叠屏供应链信号：研发进入后半程',
    status: '待回应',
    note: '采购节奏提前，容量信息仍不完整。',
  },
  {
    date: '09-04',
    articleId: '1005',
    title: '新消费关店数据：单店模型承压',
    status: '已核实',
    note: '关店点位集中在早期高租金商圈。',
  },
  {
    date: '09-01',
    articleId: '1007',
    title: '老旧小区加装电梯：三个样本对比',
    status: '多方信源',
    note: '卡点分布在费用、管线与维保三处。',
  },
];